import { useCallback, useContext, useMemo } from "react"
import { toast } from "react-toastify"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useTrainings } from "../../../../hooks/useTrainings"
import { UserContext } from "../../../context/UserContext"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../models/Authorization"
import { TrainingGet } from "../../../models/Training"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Trainings() {
  const { user } = useContext(UserContext)
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()
  const { trainingsList, isLoadingTrainings } = useTrainings()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/trainings",
    },
    { field: "applicationName", headerName: "App" },
    { field: "validityMonths", headerName: "Validity months" },
    { field: "expiryReminderDays", headerName: "Expiry reminder days" },
  ]

  const sorted = [...trainingsList].sort((a: TrainingGet, b: TrainingGet) =>
    (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((training: TrainingGet) => ({
    id: training.id,
    name: training.name,
    applicationName: training.application.name,
    validityMonths: training.validityMonths,
    expiryReminderDays: training.expiryReminderDays ?? "",
    canDelete:
      !!user &&
      hasUserAccessToApplicationFeature(
        user.authorizations.applications,
        training.application.id,
        DimaFeatureShortNameEnum.TM,
        AccessLevel.Write
      ),
  }))

  const toolbar = useMemo(
    () => <DiMaAddButton url="/trainings/create" feature={DimaFeatureShortNameEnum.TM} />,
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        if (!row.canDelete) {
          toast.error("Cannot delete item")
          return
        }
        requestDelete(() => deleteEntity(`/trainings/${row.id}`))
      }
    },
    [requestDelete]
  )

  const canDelete = rows.some((row) => row.canDelete)

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingTrainings}
        toolbar={toolbar}
        actionItems={
          canDelete
            ? [{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]
            : []
        }
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
